import { WA_POPUP_DONE_KEY } from "./waConnectionMessages";

/**
 * Opener-side watch: OAuth strips window.opener in the popup, so we detect completion via
 * a flag set on the popup window after the connect API succeeds, pathname for /wa/failure, or popup.closed.
 */
export function startWaAuthPopupPolling(popup, onFinish) {
  if (!popup) return () => {};

  const id = setInterval(() => {
    try {
      if (!popup || popup.closed) {
        clearInterval(id);
        onFinish({ reason: "closed" });
        return;
      }
      if (popup[WA_POPUP_DONE_KEY] === true) {
        clearInterval(id);
        try {
          popup.close();
        } catch (e) {
          // ignore
        }
        onFinish({ reason: "success" });
        return;
      }
      const path = popup.location?.pathname || "";
      if (path.includes("/wa/failure")) {
        clearInterval(id);
        try {
          popup.close();
        } catch (e) {
          // ignore
        }
        onFinish({ reason: "failure" });
        return;
      }
    } catch (e) {
      // Expected while popup is on another origin (Unipile).
    }
  }, 350);

  return () => clearInterval(id);
}
